const paymentTypes = {
  final: 'final',
  advance: 'advance',
  pool: 'pool',
  grading: 'grading',
};

export { paymentTypes };
